import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";

export const Route = createFileRoute("/_authenticated/fleet/reports")({
	head: () => pageTitle("Reports"),
	component: RouteComponent,
});

function RouteComponent() {
	return <div>reports</div>;
}
